import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../../helpers';
import { INTAKE_QUESTIONNAIRES_API_BASE } from '../../constants';

import type { IChildBackground, IChildInfo, IChildSchedule } from '../../../../../pages/common';
import type {
  CreateIntakeChildBackgroundPayload,
  CreateIntakeChildSchedulePayload,
  DeleteIntakeChildBackgroundPayload,
  DeleteIntakeChildSchedulePayload,
  UpdateIntakeChildInfoPayload,
} from './types';

export function createIntakeChildThunks() {
  return {
    updateIntakeChildInfo: updateIntakeChildInfo(),
    createIntakeChildBackground: createIntakeChildBackground(),
    deleteIntakeChildBackground: deleteIntakeChildBackground(),
    createIntakeChildSchedule: createIntakeChildSchedule(),
    deleteIntakeChildSchedule: deleteIntakeChildSchedule(),
  };
}

function updateIntakeChildInfo() {
  return createAsyncThunk<IChildInfo, UpdateIntakeChildInfoPayload>(
    'intakeQuestionnaire/updateIntakeChildInfo',
    async ({ intakeQuestionnaireId, data, getAccessTokenSilently }) =>
      fetchWrapper.put(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/child_info`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function createIntakeChildBackground() {
  return createAsyncThunk<IChildBackground, CreateIntakeChildBackgroundPayload>(
    'intakeQuestionnaire/createIntakeChildBackground',
    async ({ intakeQuestionnaireId, data, getAccessTokenSilently }) =>
      fetchWrapper.post(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/child_info/background`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function deleteIntakeChildBackground() {
  return createAsyncThunk<void, DeleteIntakeChildBackgroundPayload>(
    'intakeQuestionnaire/deleteIntakeChildBackground',
    async ({ intakeQuestionnaireId, backgroundId, getAccessTokenSilently }) => {
      await fetchWrapper.delete({
        url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/child_info/background/${backgroundId}`,
        getAccessTokenSilently,
      });
    },
  );
}

function createIntakeChildSchedule() {
  return createAsyncThunk<IChildSchedule, CreateIntakeChildSchedulePayload>(
    'intakeQuestionnaire/createIntakeChildSchedule',
    async ({ intakeQuestionnaireId, data, getAccessTokenSilently }) =>
      fetchWrapper.post(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/child_info/schedule`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function deleteIntakeChildSchedule() {
  return createAsyncThunk<void, DeleteIntakeChildSchedulePayload>(
    'intakeQuestionnaire/deleteIntakeChildSchedule',
    async ({ intakeQuestionnaireId, scheduleId, getAccessTokenSilently }) => {
      await fetchWrapper.delete({
        url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/child_info/schedule/${scheduleId}`,
        getAccessTokenSilently,
      });
    },
  );
}
